"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PriceTermination_1 = require("../../../price-termination/model/PriceTermination"); // tslint:disable:max-classes-per-file

/**
 * <p>During {@link SelloutTermination termination process} there may be affected {@link SelloutReleaseItem items} from multiple
 * {@link SelloutRelease releases}. Process of prices export is bound to single release and export of a release fails/succeeds
 * independently from each other. This entity encapsulates state related to termination of prices release to single release.</p>
 *
 * @author JMe
 */


var SelloutTerminationSummaryItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTerminationSummaryItem, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param rId Corresponds to {@link SelloutRelease.id}.
   * @param rName Corresponds to {@link SelloutRelease.name}.
   * @param pListType Corresponds to {@link SelloutRelease.priceListType}.
   * @param workflowType Corresponds to {@link SelloutRelease.workflowType}, but modelled as string to be more flexible.
   * @param queueId Identification of the last associated record in {@link ExportedRelease export queue}.
   * @param progressId Identification of progress related to termination of prices related to {@link this.rId}. Should be filled
   *        if there is running process of termination of prices related to the {@link SelloutRelease}.
   * @param state State of the termination process.
   */
  function SelloutTerminationSummaryItem(rId, rName, pListType, workflowType, queueId, progressId, state) {
    var _this;

    _classCallCheck(this, SelloutTerminationSummaryItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationSummaryItem).call(this));
    _this.rId = rId;
    _this.rName = rName;
    _this.pListType = pListType;
    _this.workflowType = workflowType;
    _this.queueId = queueId;
    _this.progressId = progressId;
    _this.state = state;
    return _this;
  }

  return SelloutTerminationSummaryItem;
}(DomainObject_1.DomainObject);

exports.SelloutTerminationSummaryItem = SelloutTerminationSummaryItem;

SelloutTerminationSummaryItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTerminationSummaryItem.name);
  return {
    rId: builder.str('rId'),
    rName: builder.str('rName'),
    pListType: builder.str('pListType'),
    workflowType: builder.str('workflowType'),
    queueId: builder.str('queueId'),
    progressId: builder.opt(builder.str('pExtId')),
    state: builder.senum('state', PriceTermination_1.PriceTerminationState, CodebookLookupSequence_1.CodebookLookupSequence.PriceTerminationStates)
  };
}();
/**
 * <p>Immutable implementation of {@link SelloutTerminationSummaryItemUpdatePartial}</p>
 * <p>The main purpose of this representation is to provide capability of PATCH request related to the entity. It is possible that data
 * of {@link SelloutTerminationSummaryItem} will be updated in parallel and we need to direct the update to specific summary item (rId).</p>
 *
 * @author JMe
 */


var SelloutTerminationSummaryItemUpdate =
/*#__PURE__*/
function (_DomainObject_1$Domai2) {
  _inherits(SelloutTerminationSummaryItemUpdate, _DomainObject_1$Domai2);

  /**
   * Ctor.
   *
   * @param queueId Corresponds to {@link SelloutTerminationSummaryItem.queueId}.
   * @param progressId Corresponds to {@link SelloutTerminationSummaryItem.progressId}.
   * @param state Corresponds to {@link SelloutTerminationSummaryItem.state}.
   */
  function SelloutTerminationSummaryItemUpdate(queueId, progressId, state) {
    var _this2;

    _classCallCheck(this, SelloutTerminationSummaryItemUpdate);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationSummaryItemUpdate).call(this));
    _this2.queueId = queueId;
    _this2.progressId = progressId;
    _this2.state = state;
    return _this2;
  }

  return SelloutTerminationSummaryItemUpdate;
}(DomainObject_1.DomainObject);

exports.SelloutTerminationSummaryItemUpdate = SelloutTerminationSummaryItemUpdate;